<template>    
    <BaseModal
        :id="`${modal_id}`"
        :title="title"
        :message="message"
        :size="'md'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="return;">
                <div class="modal__buttons text-center text-md-right">
                    <button type="button" class="modal__buttons__item cancel" style="width: 10rem" data-dismiss="modal" aria-label="Close" v-html="`Just this assignment`" @click="form_submit_local()"/>
                    <button class="modal__buttons__item" v-html="`Yes`" @click="form_submit_local(true)"/>
                </div>
            </form>
        </template>
    </BaseModal>
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'

export default {

    name:   'ConfirmationModalDefaultTasks',

    props: [
        'title',
        'breadcrumb',
        'count_assignments'
    ],

    components:{
        Breadcrumb,
        BaseModal,
    },

    data(){
        return{
            add_daily_tasks: true,
            add_project_tasks: true,
            modal_id: 'static-confirmation-duty-note',
            message: `Do you want to apply these changes to all assignments the note was attached to?`
        }
    },

    watch: {
        count_assignments(val)
        {
            this.message = `Do you want to apply these changes to the ${val} assignments the note was attached to?`
        }
    },

    mounted()
    {
    },

   
    methods:{
        form_submit_local(edit_all = false)
        {
            window.$(`#${this.modal_id}`).modal('hide')
            this.$emit('updateDutyNote', {edit_all})
        }
      

    },

    
}
</script>